import script from "./DynamicListBase.vue?vue&type=script&lang=ts"
export * from "./DynamicListBase.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__